
import { useNotifications } from '@/contexts/NotificationContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

export default function NotificacoesPage() {
  const { preferences, updatePreferences } = useNotifications();

  if (!preferences) {
    return (
      <div className="flex items-center justify-center h-[400px]">
        <p className="text-muted-foreground">Carregando preferências...</p>
      </div>
    );
  }

  const togglePreference = (key: keyof typeof preferences) => {
    updatePreferences({ [key]: !preferences[key] });
  };

  return (
    <div className="container py-6">
      <h1 className="text-3xl font-bold mb-6">Configurações de Notificações</h1>
      
      <div className="grid gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Canais de Notificação</CardTitle>
            <CardDescription>
              Escolha como você deseja receber suas notificações
            </CardDescription>
          </CardHeader>
          <CardContent className="grid gap-4">
            <div className="flex items-center justify-between">
              <div>
                <Label htmlFor="email">Email</Label>
                <p className="text-sm text-muted-foreground">
                  Receba notificações por email
                </p>
              </div>
              <Switch
                id="email"
                checked={preferences.email}
                onCheckedChange={() => togglePreference('email')}
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label htmlFor="push">Notificações Push</Label>
                <p className="text-sm text-muted-foreground">
                  Receba notificações no navegador
                </p>
              </div>
              <Switch
                id="push"
                checked={preferences.push}
                onCheckedChange={() => togglePreference('push')}
              />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Tipos de Notificação</CardTitle>
            <CardDescription>
              Personalize quais tipos de notificação você deseja receber
            </CardDescription>
          </CardHeader>
          <CardContent className="grid gap-4">
            <div className="flex items-center justify-between">
              <div>
                <Label htmlFor="serviceReminders">Lembretes de Serviço</Label>
                <p className="text-sm text-muted-foreground">
                  Lembretes sobre serviços agendados
                </p>
              </div>
              <Switch
                id="serviceReminders"
                checked={preferences.serviceReminders}
                onCheckedChange={() => togglePreference('serviceReminders')}
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label htmlFor="paymentReminders">Lembretes de Pagamento</Label>
                <p className="text-sm text-muted-foreground">
                  Notificações sobre pagamentos pendentes
                </p>
              </div>
              <Switch
                id="paymentReminders"
                checked={preferences.paymentReminders}
                onCheckedChange={() => togglePreference('paymentReminders')}
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label htmlFor="newMessages">Novas Mensagens</Label>
                <p className="text-sm text-muted-foreground">
                  Notificações sobre novas mensagens
                </p>
              </div>
              <Switch
                id="newMessages"
                checked={preferences.newMessages}
                onCheckedChange={() => togglePreference('newMessages')}
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label htmlFor="systemUpdates">Atualizações do Sistema</Label>
                <p className="text-sm text-muted-foreground">
                  Notificações sobre atualizações e manutenção
                </p>
              </div>
              <Switch
                id="systemUpdates"
                checked={preferences.systemUpdates}
                onCheckedChange={() => togglePreference('systemUpdates')}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
} 